// import React from 'react'
// import AddDemo from './AddDemo'
// import DemoList from './DemoList'
// import { useState } from "react";
// import SnackbarContainer from '../Snackbar';

// function DemoIndex() {
//  const [demo, setDemo] = useState(true);

//  function handleChange() {
//   setDemo(!demo)
// }
//   return (<>
//          {demo ? <DemoList handleChange={handleChange} /> : <AddDemo handleChange ={handleChange}/> }
//          <SnackbarContainer/>
//          </>
//   )
// }
// export default DemoIndex

// DemoIndex.jsx
// DemoIndex.jsx
import React, { useState } from 'react';
import DemoList from './DemoList';
import AddDemo from './AddDemo';

function DemoIndex() {
  const [showAddDemo, setShowAddDemo] = useState(false);
  const [editData, setEditData] = useState(null); // whole object from list

  // Open AddDemo in "add" mode
  const handleAddNew = () => {
    setEditData(null);
    setShowAddDemo(true);
  };

  // Open AddDemo in "edit" mode with full item
  const handleEdit = (item) => {
    setEditData(item);
    setShowAddDemo(true);
  };

  // Back to list
  const handleBackToList = () => {
    setEditData(null);
    setShowAddDemo(false);
  };

  return (
    <div>
      {showAddDemo ? (
        <AddDemo handleChange={handleBackToList} editData={editData} />
      ) : (
        <DemoList handleChange={handleAddNew} onEdit={handleEdit} />
      )}
    </div>
  );
}

export default DemoIndex;

